// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ryszs","select":"styles_select__i7s1m"};